import {  makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonClose: {
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    backgroundColor: 'rgba(215, 222, 233, 0.25)',
    '&:hover': {
      backgroundColor: 'rgba(215, 222, 233, 0.5)',
    },
  },
  iconClose: {
    width: '18px',
    height: '18px',
    color: '#4F4F4F',
  },
  formControl: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    flex: 1,
    rowGap: '15px'
  },
  button: {
    background: '#329BFC',
    color: '#fff',
    width: 200,
    height: 40,
    transition: 'filter 0.2s',
    '&:hover': {
      background: '#329BFC',
      filter: 'brightness(0.9)'
    },
    '&:disabled': {
      opacity: 0.5,
      color: '#fff'
    }
  },
}));